"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var legacy_1 = require("satcheljs/lib/legacy");
var store_1 = require("../store/store");
var setMailboxCalendarConfiguration_1 = require("../services/setMailboxCalendarConfiguration");
exports.default = legacy_1.action('saveCalendarMailboxConfiguration')(function saveCalendarMailboxConfiguration(mailboxCalendarConfiguration) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    store_1.default.calendarConfiguration = mailboxCalendarConfiguration;
                    return [4 /*yield*/, setMailboxCalendarConfiguration_1.default(mailboxCalendarConfiguration)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=saveCalendarMailboxConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/owa-calendar-configuration/lib/actions/saveCalendarMailboxConfiguration.js
// module id = 5251
// module chunks = 2